import React from "react";
import NoInvestment from "../../pages/NoInvestment/NoInvestment";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import LoadingScreen from "../LoadingScreen/LoadingScreen";
import AuthStore from "../../store/AuthStore";
import UserStore from "../../store/UserStore";
import { observer } from "mobx-react";
import { useState } from "react";
import { useEffect } from "react";
import TotalWealth from "../TotalWealth/TotalWealth";
import Transactions from "../../pages/Home/HomeContent/Transactions";
import HomeModals from "../HomeModals/HomeModals";
import NavigationCorousal from "../../pages/Home/HomeContent/NavigationCorousal";
import { homePageRoute } from "../../utils/constants";

const HomeDataContent = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(false);
  }, [UserStore.isHydrated]);

  useEffect(() => {
    const storeCards = UserStore.snippets?.data;

    if (storeCards?.length) {
    }
  }, [UserStore.snippets?.data]);

  return (
    <>
      {AuthStore.isLoadingFullScreen ||
      UserStore.homeLoad ||
      isLoading ||
      Object.values(UserStore.HomePageApiStatus).includes("pending") ? (
        // Loading screen for whole Home page and any child routes in it
        <>
          <LoadingScreen />
          <div
            id="aria-live-region"
            role="status"
            aria-live="polite"
            aria-atomic="true"
            style={{
              position: "absolute",
              width: "1px",
              height: "1px",
              overflow: "hidden",
            }}
          ></div>
        </>
      ) : !UserStore.homeRecentTransactionLength ? (
        // If Recent Transaction on Home page have empty data then whole no data screen will apear on home page
        <NoInvestment />
      ) : (
        <div>
          <Header type={homePageRoute} isLogoNavigationEnabled={false} />
          <div className="main_cont">
            <TotalWealth />
            {/* this is Recent Transaction and corporate action table which comes above footer in home page */}
            <NavigationCorousal />

            <Transactions />
            {/* All modal which gets appeared on home screen except All members switching modal */}
            <HomeModals />
          </div>
          <Footer />
        </div>
      )}
    </>
  );
};

export default observer(HomeDataContent);
